import { UPLOAD_SOURCES } from '@cld/upload-widget-common';
import { asAbsolute } from 'root/routes/utils';
import consts from '../data/consts';
import PurchasePage from '../components/PurchasePage';
import SearchPage from '../components/SearchPage';
import ShutterStockTab from '..';

const { SHUTTERSTOCK } = UPLOAD_SOURCES;

export default [
  {
    path: asAbsolute(SHUTTERSTOCK),
    component: ShutterStockTab,
    routes: [
      {
        path: asAbsolute(SHUTTERSTOCK, consts.ROUTES.PURCHASE),
        component: PurchasePage,
      },
      {
        path: asAbsolute(SHUTTERSTOCK, consts.ROUTES.SEARCH),
        component: SearchPage,
      },
    ],
  },
];
